import KitFadeView from '@omni/kit/components/KitFadeView';
import KitText from '@omni/kit/components/KitText';
import BorderRadius from '@omni/kit/theming/BorderRadius';
import Colors from '@omni/kit/theming/Colors';
import React, { ReactElement } from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import FontSize from '../../../../../theming/FontSize';
import Spacing from '../../../../../theming/Spacing';

interface BasicInfoProps {
  isVisible?: boolean;
  title?: string;
  subtitle?: string;
}

export default function BasicInfo({
  isVisible = true,
  title,
  subtitle,
}: BasicInfoProps): ReactElement {
  return (
    <KitFadeView show={isVisible} style={styles.wrapper}>
      <View style={styles.info}>
        {title ? (
          <KitText
            white
            fontSize={HeaderSize}
            bold
            style={styles.text}
            ellipsizeMode='tail'
            numberOfLines={1}
          >
            {title}
          </KitText>
        ) : null}
        {subtitle ? (
          <KitText
            white
            fontSize={FontSize.s}
            lineHeight={20}
            style={{ opacity: 0.8 }}
            ellipsizeMode='tail'
            numberOfLines={1}
          >
            {subtitle}
          </KitText>
        ) : null}
      </View>
    </KitFadeView>
  );
}

const HeaderSize = Platform.isTV ? FontSize.xxl : FontSize.xl;

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    userSelect: 'none',
    flex: 1,
  },
  info: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: Spacing.xs,
  },
  text: {
    includeFontPadding: false,
  },
  imageWrap: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: Colors.N1000,
    borderRadius: BorderRadius.full,
    justifyContent: 'center',
    height: 36,
    width: 36,
    overflow: 'hidden',
  },
});
